// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRequisitesDto } from './IRequisitesDto';
import {
    IRequisitesDtoFromJSON,
    IRequisitesDtoFromJSONTyped,
    IRequisitesDtoToJSON,
    IRequisitesDtoToJSONTyped,
} from './IRequisitesDto';
import type { IInvoiceType } from './IInvoiceType';
import {
    IInvoiceTypeFromJSON,
    IInvoiceTypeFromJSONTyped,
    IInvoiceTypeToJSON,
    IInvoiceTypeToJSONTyped,
} from './IInvoiceType';
import type { IPaymentAddressResponseDto } from './IPaymentAddressResponseDto';
import {
    IPaymentAddressResponseDtoFromJSON,
    IPaymentAddressResponseDtoFromJSONTyped,
    IPaymentAddressResponseDtoToJSON,
    IPaymentAddressResponseDtoToJSONTyped,
} from './IPaymentAddressResponseDto';

/**
 * 
 * @export
 * @interface ITransferDetailsDto
 */
export interface ITransferDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ITransferDetailsDto
     */
    payment_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ITransferDetailsDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ITransferDetailsDto
     */
    payment_status?: ITransferDetailsDtoPaymentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ITransferDetailsDto
     */
    payment_number?: number;
    /**
     * 
     * @type {Date}
     * @memberof ITransferDetailsDto
     */
    transaction_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ITransferDetailsDto
     */
    mailing_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof ITransferDetailsDto
     */
    account_number_last4?: string;
    /**
     * 
     * @type {number}
     * @memberof ITransferDetailsDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ITransferDetailsDto
     */
    trace_id?: number;
    /**
     * 
     * @type {IInvoiceType}
     * @memberof ITransferDetailsDto
     */
    invoice_type?: IInvoiceType;
    /**
     * 
     * @type {Date}
     * @memberof ITransferDetailsDto
     */
    payment_date?: Date;
    /**
     * 
     * @type {IRequisitesDto}
     * @memberof ITransferDetailsDto
     */
    requisites?: IRequisitesDto;
    /**
     * 
     * @type {string}
     * @memberof ITransferDetailsDto
     */
    payment_method_type?: ITransferDetailsDtoPaymentMethodTypeEnum;
    /**
     * 
     * @type {IPaymentAddressResponseDto}
     * @memberof ITransferDetailsDto
     */
    payment_address_response_dto?: IPaymentAddressResponseDto;
    /**
     * 
     * @type {string}
     * @memberof ITransferDetailsDto
     */
    payment_document_path?: string;
}

/**
* @export
* @enum {string}
*/
export enum ITransferDetailsDtoPaymentStatusEnum {
    PENDING = 'PENDING',
    ISSUED = 'ISSUED',
    CLEARED = 'CLEARED',
    VOIDED = 'VOIDED',
    EXPIRED = 'EXPIRED',
    EXPIRING = 'EXPIRING',
    REISSUING = 'REISSUING',
    VOIDING = 'VOIDING',
    SENT = 'SENT',
    REJECTED = 'REJECTED'
}
/**
* @export
* @enum {string}
*/
export enum ITransferDetailsDtoPaymentMethodTypeEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}


/**
 * Check if a given object implements the ITransferDetailsDto interface.
 */
export function instanceOfITransferDetailsDto(value: object): value is ITransferDetailsDto {
    return true;
}

export function ITransferDetailsDtoFromJSON(json: any): ITransferDetailsDto {
    return ITransferDetailsDtoFromJSONTyped(json, false);
}

export function ITransferDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITransferDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payment_id': json['payment_id'] == null ? undefined : json['payment_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'payment_status': json['payment_status'] == null ? undefined : json['payment_status'],
        'payment_number': json['payment_number'] == null ? undefined : json['payment_number'],
        'transaction_date': json['transaction_date'] == null ? undefined : (new Date(json['transaction_date'])),
        'mailing_date': json['mailing_date'] == null ? undefined : (new Date(json['mailing_date'])),
        'account_number_last4': json['account_number_last4'] == null ? undefined : json['account_number_last4'],
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'trace_id': json['trace_id'] == null ? undefined : json['trace_id'],
        'invoice_type': json['invoice_type'] == null ? undefined : IInvoiceTypeFromJSON(json['invoice_type']),
        'payment_date': json['payment_date'] == null ? undefined : (new Date(json['payment_date'])),
        'requisites': json['requisites'] == null ? undefined : IRequisitesDtoFromJSON(json['requisites']),
        'payment_method_type': json['payment_method_type'] == null ? undefined : json['payment_method_type'],
        'payment_address_response_dto': json['payment_address_response_dto'] == null ? undefined : IPaymentAddressResponseDtoFromJSON(json['payment_address_response_dto']),
        'payment_document_path': json['payment_document_path'] == null ? undefined : json['payment_document_path'],
    };
}

export function ITransferDetailsDtoToJSON(json: any): ITransferDetailsDto {
    return ITransferDetailsDtoToJSONTyped(json, false);
}

export function ITransferDetailsDtoToJSONTyped(value?: ITransferDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_id': value['payment_id'],
        'amount': value['amount'],
        'payment_status': value['payment_status'],
        'payment_number': value['payment_number'],
        'transaction_date': value['transaction_date'] == null ? undefined : ((value['transaction_date']).toISOString()),
        'mailing_date': value['mailing_date'] == null ? undefined : ((value['mailing_date']).toISOString()),
        'account_number_last4': value['account_number_last4'],
        'invoice_id': value['invoice_id'],
        'trace_id': value['trace_id'],
        'invoice_type': IInvoiceTypeToJSON(value['invoice_type']),
        'payment_date': value['payment_date'] == null ? undefined : ((value['payment_date']).toISOString().substring(0,10)),
        'requisites': IRequisitesDtoToJSON(value['requisites']),
        'payment_method_type': value['payment_method_type'],
        'payment_address_response_dto': IPaymentAddressResponseDtoToJSON(value['payment_address_response_dto']),
        'payment_document_path': value['payment_document_path'],
    };
}

